import { render, staticRenderFns } from "./TaskShortItem.vue?vue&type=template&id=58527fff&scoped=true&"
import script from "./TaskShortItem.vue?vue&type=script&lang=js&"
export * from "./TaskShortItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskShortItem.vue?vue&type=style&index=0&id=58527fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58527fff",
  null
  
)

export default component.exports